import { module } from 'modujs';

export default class Squish extends module {

    static get settings() {
        return {
            CLASSNAME: 'c-squish',
            ACTIVE_CLASS:'is-open',
        }
    }

    constructor(m) {
        super(m);

        // DOM Elements
        this.$items = Array.from(this.$('item'))
        this.$containers = Array.from(this.$('container'))
        this.$contents = Array.from(this.$('content'))
        this.$togglers = Array.from(this.$('toggler'))

        // Opened state if data-squish-opened
        this.currentIndex = -1
        this.durations = []

        // Events
        this.events = {
            click: {
                'toggler': 'toggle'
            },
        }
    }

    init() {

        for(let $item of this.$items) {
            $item.classList.add(Squish.settings.CLASSNAME)
        }

        // Set sizes
        this.resize()

        // Bind keyboard events
        this.onKeydown = (e) => {
           if(e.code === 'Space' || e.code === 'Enter') {
                this.toggle()
            }
        }

        this.$togglers.forEach(($toggler, i) => {
            $toggler.addEventListener('keydown', this.onKeydown)
            $toggler.dataset.index = i
        })

        // Add window event
        window.addEventListener('resize', this.onResize = () => this.resize())
    }

    toggle(e) {
        const index = Number(e.curTarget.dataset.index)

        if(this.currentIndex === index) {
            this.close()
        } else {

            if(this.currentIndex >= 0) {
                this.close()
            }

            this.open(index)
        }
    }

    open(i) {
        this.$items[i].classList.add(Squish.settings.ACTIVE_CLASS)
        this.$togglers[i].setAttribute('aria-expanded', 'true')
        this.currentIndex = i

        // Clear close callback
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
        }

        // Set open callback
        this.openTimeout = setTimeout(() => {

            // Callback function
            // console.log('Squish opened')

        }, this.durations[i])
    }

    close() {
        const i = this.currentIndex

        if(i < 0) {
            return
        }

        this.$items[i].classList.remove(Squish.settings.ACTIVE_CLASS)
        this.$togglers[i].setAttribute('aria-expanded', 'false')
        this.currentIndex = -1

        // Clear open callback
        if (this.openTimeout) {
            clearTimeout(this.openTimeout);
        }

        // Set close callback
        this.closeTimeout = setTimeout(() => {

            // Callback function
            // console.log('Squish closed')

        }, this.durations[i]);
    }

    resize() {

        let height, duration
        this.$items.forEach(($item, i) => {

            // Set content height
            height = this.$contents[i].offsetHeight
            $item.style.setProperty('--squish-container-height', `${height}px`)

            // Get styles
            duration = window.getComputedStyle($item).getPropertyValue('--squish-duration');
            this.$containers[i].style.setProperty('--squish-duration', duration);
            this.durations[i] = 1000 * parseInt(duration, 10);
        })

    }

    destroy() {

        // Unbind keyboard events
        for(let $toggler of this.$togglers) {
            $toggler.removeEventListener('keydown', this.onKeydown)
        }

        // Remove window event
        window.removeEventListener('resize', this.onResize)
    }
}
